<template>
<div>
    <div class="pre-teste h-screen flex flex-col justify-center">

        <div class="text-center container ">
            <img class="mx-auto responsive" src="@/assets/images/novaintegracao/fim-top.png" alt="">
            <h1 class="sm:text-4xl md:text-6xl mt-4 text-white font-black">Que bom que chegou até aqui, {{userisloged.name}}!</h1>

            <div class="text-white sm:text-lg md:text-2xl mx-auto" style="max-width:660px;">
                <p class="mt-8 md:mt-4">Muito obrigado por chegar até essa fase da nossa integração</p>
                <p class="md:mt-4" >Agora vamos precisar conferir certinho se você conseguiu pegar realmente tudo que nós queremos te passar nessa fase da integração.</p>
                <p class="md:mt-4">Para realmente sabermos isso vamos lhe fazer algumas perguntas relacionadas ao que lhe mostramos.
Não se preocupe! Você pode repetir o teste quantas vezes quiser e também pode voltar para os nossos slides quando quiser também.</p>
            </div>

            <h2 class="mt-8 md:mt-0 text-white text-2xl font-black">E ai está preparado?</h2>

            <div class="footer mt-8 md:mt-4 container flex flex-col">
                <div class="flex md:my-10 mx-auto text-center text-white">
                    <button class="btn-back roboto md:text-lg p-2 md:p-4 mx-2 md:mx-5" @click="goToSlides">Não, voltar para slides</button>
                    <button class="btn-next roboto md:text-lg p-2 md:p-4 mx-2 md:mx-5" @click="goToTeste">Sim, vamos ao teste</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
  import  novotopo from './Paginas/topo.vue'
  import  conteudotext from './Paginas/ConteudoTexto.vue'
  import  conteudovideo from './Paginas/ConteudoVideo.vue'
  import  footerintegracao from './Paginas/footer.vue'
  import  diferenciais from './Paginas/Diferenciais.vue'
  import  horarios from './Paginas/horarios.vue'

  import moduleIntegracao from "../../store/integracao/moduleIntegracao";

  // Base css
  import "@/assets/css/integracao.css";

  export default {
    name: "Main",
    components:{
      novotopo,
      conteudotext,
      footerintegracao,
      conteudovideo,
      diferenciais,
      horarios,
    },
    created() {
      if (!this.userisloged){
        this.$router.push({name:'novaintegracao-login'})
      }
      if (!moduleIntegracao.isRegistered) {
        this.$store.registerModule("integracao", moduleIntegracao);
        moduleIntegracao.isRegistered = true;
      }
      this.getPaginas();
      console.log('Variavel',this.paginas)
    },
    computed: {
      currentStep() {
        return this.$store.state.integracao.step;
      },
      userisloged(){
        let user = localStorage.getItem('integracaoLogged')
        return JSON.parse(user);

      }
    },
    methods: {
      goToSlides(){
        this.$router.push({name:'integracao-slides',params:{id:1}})
      },

      goToTeste(){
        this.$router.push({name:'integracao-avaliacao',params:{id:1}})
      },
    },
    data(){
      return{
        paginaAtual:0,
        user:'Ana',
        paginas:[],
        backgroundLoading: '#ffffff',
      }
    }
  };
</script>
<style scoped>

    .pre-teste{
        background-image: url('../../assets/images/novaintegracao/bgfim.png') !important;
        background-size: cover;
    }
    .btn-back,
    .btn-next{
        width: auto;
        letter-spacing: 5px;
        color: #fff !important;
    }
    .btn-back{
        background-color: transparent;
    }

    .btn-next{
        background-color: #F0A977;
        border: #CFCFCF 2px solid;
    }

    @media(max-width: 700px){
    .btn-back,
    .btn-next{
        letter-spacing: 3px;
    }
    }
</style>
